import { render, staticRenderFns } from "./infoWindow.vue?vue&type=template&id=036a3142&scoped=true"
import script from "./infoWindow.vue?vue&type=script&lang=js"
export * from "./infoWindow.vue?vue&type=script&lang=js"
import style0 from "./infoWindow.vue?vue&type=style&index=0&id=036a3142&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036a3142",
  null
  
)

export default component.exports